// extracted by mini-css-extract-plugin
export default {"container":"components-help-center-module__container"};